module.exports = __webpack_public_path__ + "img/heart.471c7711.png";